import * as types from "./types";
import {
    getEmployeeTrainingListAxios,
    deleteEmployeeTrainingAxios,
    postEmployeeTrainingAxios,
    putEmployeeTrainingAxios,
    getEmployeeTrainingByIDAxios
} from "./services";

export async function getEmployeeTrainingListAction({ commit }, payload) {
    commit(types.LOADING_EMPLOYEE_TRAINING, true);
    try {
        const { data } = await getEmployeeTrainingListAxios(payload);
        commit(types.GET_EMPLOYEE_TRAINING_LIST, data.result.data);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_EMPLOYEE_TRAINING, false);
    }
}

export async function removeEmployeeTrainingAction({ commit }, payload) {
    commit(types.LOADING_EMPLOYEE_TRAINING, true);
    try {
        console.log('delete', payload)
       const response =  await deleteEmployeeTrainingAxios(payload);
        commit(types.REMOVE_EMPLOYEE_TRAINING, payload);
        return response
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_EMPLOYEE_TRAINING, false);
    }
}

export async function addEmployeeTrainingAction({ commit }, payload) {
    commit(types.LOADING_EMPLOYEE_TRAINING, true);
    try {
       const response = await postEmployeeTrainingAxios(payload);
        commit(types.ADD_EMPLOYEE_TRAINING, payload);
        return response;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_EMPLOYEE_TRAINING, false);
    }
}

export async function updateEmployeeTrainingAction({ commit }, payload) {
    commit(types.LOADING_EMPLOYEE_TRAINING, true);
    try {
        const response =   await putEmployeeTrainingAxios(payload);
        commit(types.UPDATE_EMPLOYEE_TRAINING, payload);
        return response;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_EMPLOYEE_TRAINING, false);
    }
}


export async function getEmployeeTrainingByIDAction({commit}, payload) {
    commit(types.LOADING_EMPLOYEE_TRAINING, true);
    try {
        
        const {data} = await getEmployeeTrainingByIDAxios(payload);
        commit(types.GET_EMPLOYEE_TRAINING_BY_ID, data.result);
    }
    catch(e) {
        throw e;
    }
    finally {
        commit(types.LOADING_EMPLOYEE_TRAINING, false);
    }
   
}